/**
 * @generated SignedSource<<ca5de180b5fa1047240fefa6f69a952f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type routeCommunityShellEnabledQuery$variables = {
  slug: string;
};
export type routeCommunityShellEnabledQuery$data = {
  readonly club: {
    readonly configuration: string | null | undefined;
  };
};
export type routeCommunityShellEnabledQuery = {
  response: routeCommunityShellEnabledQuery$data;
  variables: routeCommunityShellEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COMMUNITY_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeCommunityShellEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeCommunityShellEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "30e352ccd61f9e5995e98a0cbbfc9717",
    "id": null,
    "metadata": {},
    "name": "routeCommunityShellEnabledQuery",
    "operationKind": "query",
    "text": "query routeCommunityShellEnabledQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"COMMUNITY_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c224d0b66c994284e8b572483d6a5a8c";

export default node;
